
// import lib
import isEmpty from '../../lib/isEmpty';


export const OrderValidate = (value) => {


    let errors = {};

    if (isEmpty(value.quantity)) {
        errors.quantity = "QUANTITY_REQUIRED"
        return errors;
    } else if (isNaN(value.quantity)) {
        errors.quantity = "QUANTITY_ERROR"
        return errors;
    } else if (parseFloat(value.quantity) <= 0) {
        errors.quantity = "QUANTITY_GRATER"
        return errors;
    }

    if (isEmpty(value.buyorsell)) {
        errors.buyorsell = "SIDE_REQUIRED"
        return errors;
    } else if (!['buy', 'sell'].includes(value.buyorsell)) {
        errors.value = "INVALID_SIDE"
        return errors;
    }

    if (isEmpty(value.pairId)) {
        errors.pairId = "PAIR_REQUIRED"
        return errors;
    }
}